// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1f82e","requiredAsterisk":"Info_requiredAsterisk__18ZzU"};